import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarIcon, RefreshCcw } from "lucide-react";
import "./DateRangePicker.css";

type Props = {
  value: [Date | null, Date | null];
  onChange: (range: [Date | null, Date | null]) => void;
  maxDate?: Date;
  placeholder?: string;
};

export default function DateRangePicker({
  value,
  onChange,
  maxDate,
  placeholder = "Select date range",
}: Props) {
  const [startDate, endDate] = value;
  const today = maxDate ?? new Date();

  const handleDateChange = (update: [Date | null, Date | null]) => {
    onChange(update);
  };

  const clearDates = () => {
    onChange([null, null]);
  };

  return (
    <div className="flex items-center gap-3 relative">
      <div className="flex items-center gap-2 bg-white rounded-lg border border-gray-300 h-10 px-3 shadow-sm min-w-[200px] relative w-full">
        <CalendarIcon className="w-4 h-4 text-gray-500" />
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={(r: any) =>
            handleDateChange(r as [Date | null, Date | null])
          }
          shouldCloseOnSelect={false}
          maxDate={today}
          placeholderText={placeholder}
          className="text-sm outline-none w-full"
          dateFormat="dd/MM/yy"
          popperProps={{
            strategy: "fixed",
          }}
          popperClassName="date-picker-popper"
        />
        {(startDate || endDate) && (
          <button
            onClick={clearDates}
            className="absolute right-2 text-gray-500 hover:text-red-500 transition"
            aria-label="Clear dates"
            type="button"
          >
            <RefreshCcw className="w-4 h-4 hover:text-brand-blue transition" />
          </button>
        )}
      </div>
    </div>
  );
}
